import { Grid } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { NoteEditor, NoteHistory } from "./component";
import { isDesktop } from "react-device-detect";

const useStyles = makeStyles((theme: Theme) => ({
	fullHeight: {
		height: "100%",
	},
}));

const Notes = ({ notes, selectedNote, handleNoteSelect, onTextChange, allowedEdit, handleEditNoteFeature }) => {
	const classes = useStyles();
	return (
		<Grid container direction="row" className={classes.fullHeight}>
			<>
				{(!allowedEdit || isDesktop) && (
					<NoteHistory
						selectedNote={selectedNote}
						notes={notes}
						handleNoteSelect={handleNoteSelect}
						handleEditNoteFeature={handleEditNoteFeature}
					/>
				)}
				{(allowedEdit || isDesktop) && <NoteEditor selectedNote={selectedNote} onTextChange={onTextChange} />}
			</>
		</Grid>
	);
};

export default Notes;
